<!-- <router-outlet></router-outlet> -->
<div>
    <!-- Outlet to show the Login screen -->
    <router-outlet *ngIf="!showHeader"></router-outlet>
    <!-- Container to be shown if not in the Login screen -->
    <div *ngIf="showHeader">
        <app-navigation-layout></app-navigation-layout>
    </div>

    <ngx-spinner type="line-scale-party">
        <p class="loading">{{spinnerText}}</p>
    </ngx-spinner>
</div>
